export default __webpack_public_path__ + "static/media/remove.7e26ca82.mp3";